import { ArticleType } from "@kvix/shared";
import React from "react";
import { CardBase } from "./partials/CardBase";
import { CardMeta } from "./partials/CardMeta";
import { CardWrapper } from "./partials/CardWrapper";
export const InstructorCard = (props) => {
    var _a;
    return (React.createElement(CardWrapper, null,
        React.createElement(CardBase, { instructorLayout: true, imageUrl: props.options.imageUrl, title: props.options.title, link: `/${props.type === ArticleType.INSTRUCTOR ? "instructor" : "streamer"}/${props.options.id}`, noOfFollowers: props.options.noOfFollowers, partnerTitle: props.options.partnerTitle }),
        props.displayMeta && (React.createElement(CardMeta, { description: props.options.description, language: ((_a = props.options.tags) === null || _a === void 0 ? void 0 : _a.includes("English")) ? "English" : "Swedish" }))));
};
//# sourceMappingURL=InstructorCard.js.map